import store from '../store/index.js'
import Cart from "../constructors/Cart.js"

export default {
  getCart() {
      return axios.get(process.env.VUE_APP_ROOT_API + '/checkout/cart', {
        params: {
          cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
          locale: store.state.app.locale.code,
          channel: store.state.app.channel.code,
          currency: store.state.app.currency.code,
        }
      }
      ).then(response => {
        store.commit('mutateCart',response.data.data);
        return response.data.data;
      }).catch(error => {
        console.log(error);
      })
  },

  addSimpleProductToCart(product_id) {
      return axios.post(process.env.VUE_APP_ROOT_API + '/checkout/cart/add/' + product_id, {
        cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
        "product_id":product_id,
        "quantity": 1,
        "is_configurable":false
      }
      ).then(response => {

        store.commit('mutateCart',response.data.data);
        store.commit('mutateShippingRates',response.data.data.shipping_rates);
        return response.data;
      }).catch(error => {
        throw error;
      })
  },
  addConfigurableProductToCart(lineItem) {
      return axios.post(process.env.VUE_APP_ROOT_API + '/checkout/cart/add/' + lineItem.product_id, {
        cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
        "product_id":lineItem.product_id,
        "quantity": 1,
        "is_configurable":true,
        "selected_configurable_option" : lineItem.selected_configurable_option,
        "super_attribute" : {
          "attribute_id":"attribute_option_id",
          // "attribute_id":"attribute_option_id"
        }
      }
      ).then(response => {
        store.commit('mutateCart',response.data.data);
        store.commit('mutateShippingRates',response.data.data.shipping_rates);
        return response.data.data;
      }).catch(error => {
        console.log(error);
      })
  },
  removeItemFromCart(item_id) {
      return axios.get(process.env.VUE_APP_ROOT_API + '/checkout/cart/remove-item/' + item_id, {
        cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
      }
      ).then(response => {
        store.commit('mutateCart',response.data.data);
        store.commit('mutateShippingRates',response.data.data.shipping_rates);
        return response.data.data;
      }).catch(error => {
        console.log(error);
      })
  },
  saveAddressToCart(address) {
      return axios.post(process.env.VUE_APP_ROOT_API + '/checkout/save-address', {
        address,
        cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
      }).then(response => {
        store.commit('mutateCart',response.data.data.cart);
        store.commit('mutateShippingRates',response.data.data.shipping_rates);
        return response.data.data;
      }).catch(error => {
        console.log(error);
      })
  },
  saveShippingMethodToCart(shippingMethod) {
      return axios.post(process.env.VUE_APP_ROOT_API + '/checkout/save-shipping', {
        "cart_id": store.state.checkout.cart ? store.state.checkout.cart.id : 'null', // if a previous cart_id is in store, send it along..
        "shipping_method": shippingMethod
      }
      ).then(response => {
        store.commit('mutateCart',response.data.data.cart);
        store.commit('mutatePaymentMethods',response.data.data.methods);
        return response.data.data;
      }).catch(error => {
        console.log(error);
      })
  },
  savePaymentMethodToCart(paymentMethod) {
      return axios.post(process.env.VUE_APP_ROOT_API + '/checkout/save-payment', {
        cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
        'payment': {
            'method': paymentMethod
        }
      }
      ).then(response => {
        store.commit('mutateCart',response.data.data.cart);
        return response.data.data;
      }).catch(error => {
        console.log(error);
      })
  },
  applyCouponToCart(couponCode) {
      return axios.post(process.env.VUE_APP_ROOT_API + '/checkout/cart/apply-coupon', {
        couponCode: couponCode,
        cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
      }
      ).then(response => {
        if (response.data.cart != undefined) {
          store.commit('mutateCart',response.data.cart);
        }
        return response.data;
      }).catch(error => {
        console.log(error);
      })
  },
  removeCoupon() {
      return axios.get(process.env.VUE_APP_ROOT_API + '/checkout/cart/remove-coupon',{
        params: {
          cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
          locale: store.state.app.locale.code,
          channel: store.state.app.channel.code,
          currency: store.state.app.currency.code,
        }
      })
      .then(response => {
        if (response.data.cart != undefined) {
          store.commit('mutateCart',response.data.cart);
        }
        return response.data;
      }).catch(error => {
        console.log(error);
      })
  },
  saveOrder() {
      return axios.post(process.env.VUE_APP_ROOT_API + '/checkout/save-order', {
        cart_id: store.state.checkout.cart ? store.state.checkout.cart.id : null, // if a previous cart_id is in store, send it along..
      },
      ).then(response => {
        store.commit('mutateOrder', response.data.order);
        return response.data;
      }).catch(error => {
        console.log(error);
      })
  },

}
